import { WidgetsKindEnum, WidgetTemplatesKindEnum } from 'graphql-common';

// Widget template kinds that can be created/managed by users
export const CREATABLE_WIDGET_TEMPLATE_KINDS = [
  WidgetTemplatesKindEnum.Announcement,
  WidgetTemplatesKindEnum.ExternalLink,
] as const;

export const breakpoints = { lg: 3000 };
export const cols = { lg: 12 };
export const resizeHandles = ['se', 'nw', 'sw', 'ne'] as const;
export const margin: [number, number] = [16, 16];
export const padding: [number, number] = [0, 0];
export const draggableHandle = 'drag-handle';
export const rowHeight = 32;

// Widget size constraints (width x height in grid units)
export interface WidgetSizeConstraints {
  minW: number;
  minH: number;
  maxW: number;
  maxH: number;
  // Default size when creating a new widget
  defaultW: number;
  defaultH: number;
}

// Size constraints for each widget type
export const WIDGET_SIZE_CONSTRAINTS: Record<string, WidgetSizeConstraints> = {
  [WidgetsKindEnum.WeatherToday]: {
    minW: 5,
    minH: 6,
    maxW: 12,
    maxH: 8,
    defaultW: 5,
    defaultH: 6,
  },
  [WidgetsKindEnum.WeatherWeek]: {
    minW: 4,
    minH: 3,
    maxW: 12,
    maxH: 6,
    defaultW: 12,
    defaultH: 4,
  },
  [WidgetsKindEnum.Clock]: {
    minW: 3,
    minH: 5,
    maxW: 12,
    maxH: 8,
    defaultW: 6,
    defaultH: 6,
  },
  [WidgetsKindEnum.QuickCreation]: {
    minW: 4,
    minH: 5,
    maxW: 12,
    maxH: 5,
    defaultW: 12,
    defaultH: 5,
  },
  [WidgetsKindEnum.SitesMap]: {
    minW: 6,
    minH: 8,
    maxW: 12,
    maxH: 16,
    defaultW: 12,
    defaultH: 20,
  },
  [WidgetsKindEnum.ActiveInterventions]: {
    minW: 6,
    minH: 8,
    maxW: 12,
    maxH: 16,
    defaultW: 12,
    defaultH: 20,
  },
  [WidgetsKindEnum.SectorsPerformanceMetricsByDeadlinesMissed]: {
    minW: 6,
    minH: 8,
    maxW: 12,
    maxH: 16,
    defaultW: 12,
    defaultH: 20,
  },
  [WidgetsKindEnum.SitesPerformanceMetricsByDeadlinesMissed]: {
    minW: 6,
    minH: 8,
    maxW: 12,
    maxH: 16,
    defaultW: 12,
    defaultH: 20,
  },
  [WidgetsKindEnum.Announcement]: {
    minW: 5,
    minH: 4,
    maxW: 12,
    maxH: 8,
    defaultW: 12,
    defaultH: 5,
  },
  [WidgetsKindEnum.ExternalLink]: {
    minW: 3,
    minH: 2,
    maxW: 6,
    maxH: 2,
    defaultW: 4,
    defaultH: 2,
  },
};

// Default constraints for unknown widget types
export const DEFAULT_WIDGET_CONSTRAINTS: WidgetSizeConstraints = {
  minW: 3,
  minH: 3,
  maxW: 12,
  maxH: 12,
  defaultW: 3,
  defaultH: 3,
};

/**
 * Get size constraints for a widget type
 */
export function getWidgetSizeConstraints(kind: string): WidgetSizeConstraints {
  return WIDGET_SIZE_CONSTRAINTS[kind] || DEFAULT_WIDGET_CONSTRAINTS;
}

// Legacy defaults (kept for backward compatibility)
export const DEFAULT_WIDGET_WIDTH = 3;
export const DEFAULT_WIDGET_HEIGHT = 3;
